import { allSdgIds, SdgAlignmentValence, SdgId } from '@upright/common/model/output/scores/sdg-alignment/types';
import { parse, ParsedUrlQuery, stringify } from 'querystring';

export interface SdgLensSelectionState {
  sdg?: SdgId;
  valence?: SdgAlignmentValence;
}

function serializeSelectionState(state: SdgLensSelectionState) {
  return stringify({
    valence: state.valence,
    sdg: state.sdg,
  });
}

function unserializeSelectionState(value: string | undefined): SdgLensSelectionState {
  if (!value) {
    return {};
  }
  const parsed: ParsedUrlQuery = parse(value);

  function parseSdg(val: string | undefined) {
    if (!value) {
      return undefined;
    }
    if (allSdgIds.indexOf(val as SdgId) !== -1) {
      return val as SdgId;
    }
    return undefined;
  }

  function parseValence(val: unknown) {
    if (!val) {
      return undefined;
    }
    switch (val) {
      case SdgAlignmentValence.ALIGNED:
        return SdgAlignmentValence.ALIGNED;
      case SdgAlignmentValence.MISALIGNED:
        return SdgAlignmentValence.MISALIGNED;
      default:
        return undefined;
    }
  }

  return {
    sdg: parseSdg(parsed.sdg as string),
    valence: parseValence(parsed.valence as string),
  };
}

function isImpactHighlighted() {
  return false;
}

export const sdgLensSelectionState = {
  serializeSelectionState,
  // TODO Can this be removed?
  unserializeSelectionState,
  isImpactHighlighted,
};
